import React from 'react'
import JsBarcode from 'jsbarcode';

type Props = {
    value:string,
    barcodeProperties: {
        height: number, 
        textPosition: string, 
        fontSize: number, 
        marginTop: number
    }
}

const Barcode = (props: Props) => {
    React.useEffect(() => {
        JsBarcode("#barcode")
            .options({font: "OCR-B"}) 
            .CODE128(props.value, props.barcodeProperties)
            .render();
    },[props.value])

    return (
        <svg id="barcode"></svg>
    )
}

export default Barcode